import logger, { enableLog, disableLog } from '@/logger'

const plugin =
  (store) => {
    store.subscribe(() => {
      if (!store.getters['featureToggles/canUseLogFile']) {
        disableLog()
      } else {
        enableLog()
      }
    })

    const actionLog = logger.extend('vuex:action')

    // Log actions
    store.subscribeAction({
      after: (action) => {
        actionLog(`completed: ${action.type}`, action.payload)
      },
    })
  }

export default {
  plugin,
}
